<template>
	<div>
		<el-form size="mini" :inline="true" class="demo-form-inline">
			 <el-form-item label="账单生成时间">
			 	<el-date-picker
						v-model="value"
						type="daterange"
						align="right"
						unlink-panels
						placeholder="选择日期"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
                        :clearable="clearable"
						:picker-options="pickerOptions">
			    </el-date-picker>
			 </el-form-item>
		  <el-form-item>
		    <el-button type="primary" @click="onSearch">查询</el-button>
		    <el-button @click="resetForm">重置</el-button>
		  </el-form-item>
		</el-form>
		<div class="line"></div>
		<el-table
                v-loading="loading"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    prop="scheduleBillCode"
                    label="账单编号"
                    :show-overflow-tooltip="true"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="checkoutCommercialName"
                    label="商户名称"
                    :show-overflow-tooltip="true"
                    width="160">
            </el-table-column>
            <el-table-column
                    prop="expectPayDate"
                    label="账单生成时间"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="businessStartDate"
                    label="账单开始时间"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="businessEndDate"
                    label="账单结束时间"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="billAmount"
                    label="应付俺来也款项"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="billAmount"
                    label="开票金额"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="billStatusStr"
                    label="账单状态"
                    width="120">
            </el-table-column>
            <el-table-column
                    prop="actualPayDate"
                    label="付款时间">
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    fixed="right"
                    width="200"
                    header-align="center"
                    align="center"
                    >
                    <template slot-scope="scope">
                    	<el-button type="text" @click="exportExcel(scope.$index)">导出明细</el-button>
	                    <el-button v-if='scope.row.isCanConfirmPayment===1' type="text" @click="payButton(scope.row.scheduleBillCode)">确认付款</el-button>
	                </template>    
            </el-table-column>
        </el-table>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		name: 'FinancePayList',
		data () {
			return {
				 pickerOptions: {
		          disabledDate(time) {
		            return time.getTime() > Date.now();
		          },
		          shortcuts: [{
		            text: '最近一周',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近一个月',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近三个月',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
		              picker.$emit('pick', [start, end]);
		          	}
		          }],
		        },
		        value: [],
		        queryForm: {
                    pageSize: 10,
                    pageNo: 1,
					for_report: true
                },
		        loading: false,
                clearable: false,
                tableData: [],
		    }
		},
        created(){
            //默认显示最近一周
            if(this.$route.query.date){
                let temp = [];
                temp = this.$route.query.date.split('-');
                this.value = [new Date(temp[0],temp[1]-1,temp[2]),new Date(temp[0],temp[1]-1,temp[2])];
            }else{
                var day = new Date();
                day.setTime(day.getTime()-7*24*60*60*1000);
                this.value = [day,new Date()];
            }
            this.onSearch();
        },
		methods: {
			getParams() {
                let params = {...this.queryForm};
                params.startDate = moment(this.value[0]).format('YYYYMMDD').toString();
                params.endDate = moment(this.value[1]).format('YYYYMMDD').toString();
                return params;
            },
			onSearch() {
				if(this.value.length > 0) {
					let params = this.getParams();
					this.$apiJava.post(this.$apiUrl.financePayList,params,(res)=>{
						this.loading = false;
                    	this.tableData = res.data.list || [];
                },(res)=>{
                    this.$message.warning(res.message);
                    this.loading = false;
                    this.tableData = [];
                },'finance')
				} else {
					this.$message.error('请选择正确日期');
				}
			},
			resetForm() {
                this.value = [];
                this.tableData = [];
            },
            payButton(BillCode) {
            	let params = {
            		scheduleBillCode: BillCode,
            		type: 1
            	};
                this.$confirm('是否确认支付?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$apiJava.post(this.$apiUrl.financePayListBillModify,params,(res)=>{
                    this.$message.success("支付成功");
                    this.onSearch();
                },(res)=>{
                    this.$message.warning(res.message);
                },'finance')
                }).catch(() => {
                    this.$message({
                    type: 'info',
                    message: '已取消支付'
                    });          
                });
            },
            exportExcel (index) {
            	 var params = {
            	 	scheduleBillCode: this.tableData[index].scheduleBillCode,
            	 	commercialId: this.tableData[index].checkoutCommercialId,
            	 	schoolId: this.tableData[index].schoolId,
            	 	startDate: this.tableData[index].businessStartDate.split("-").join(""),
            	 	endDate: this.tableData[index].businessEndDate.split("-").join("")
            	 };
			    let hostStr = window.location.host;
			    let host = hostStr.replace('e','finance');
			    let url = location.protocol +'//'+ host + '/' + this.$apiUrl.financeExport + '?scheduleBillCode=' + params.scheduleBillCode + '&commercialId=' + params.commercialId + '&schoolId=' + params.schoolId + '&startDate=' + params.startDate + '&endDate=' + params.endDate;
			    console.log(url);
			    window.open(url);
            	console.log(params);
            	// console.log(this.tableData[1]);
            }
		}
	}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// payList.vue?2aba27ba